// Auto-scale kW/kWh → MW/MWh when a value has more than 3 digits (abs >= 1000).
// Used only on the inline Metric page for Discom Substation / Feeder granularity,
// where the API emits kW/kWh. NOT applied inside modals.

const SCALE_MAP: Record<string, string> = {
  kW: "MW",
  kWh: "MWh",
};

export function scaleUnit(
  value: number | null | undefined,
  unit: string,
): { value: number | null | undefined; unit: string } {
  const scaledUnit = SCALE_MAP[unit];
  if (scaledUnit == null || value == null || !isFinite(value)) {
    return { value, unit };
  }
  if (Math.abs(value) >= 1000) {
    return { value: value / 1000, unit: scaledUnit };
  }
  return { value, unit };
}
